import React from 'react';

export default function ScrollingTextMarquee() {
  const text = "AI Strategy – AI Development – Intelligent Automation";

  return (
    <>
      <style>{`
        .marquee-container {
          width: 100%;
          overflow: hidden;
          background-color: #ffffff;
          padding: 40px 0;
          position: relative;
        }

        .marquee-content {
          display: flex;
          animation: scroll 15s linear infinite;
          white-space: nowrap;
        }

        .marquee-text {
          font-size: 5rem;
          font-weight: 700;
          color: #1a1a1a;
          display: flex;
          align-items: center;
          padding-right: 100px;
        }

        .marquee-text span {
          display: inline-block;
        }

        .text-dark {
          color: #1a1a1a;
        }

        .text-dark {
          color: #1a1a1a;
        }

        .scroll-badge {
          position: absolute;
          right: 40px;
          top: 50%;
          transform: translateY(-50%);
          background-color: #1a1a1a;
          color: white;
          writing-mode: vertical-rl;
          text-orientation: mixed;
          padding: 10px 8px;
          font-size: 8px;
          font-weight: 600;
          letter-spacing: 2px;
          border-radius: 30px;
          z-index: 10;
        }

        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        /* Pause animation on hover */
        .marquee-container:hover .marquee-content {
          animation-play-state: paused;
        }

        @media (max-width: 968px) {
          .marquee-text {
            font-size: 3rem;
          }

          .scroll-badge {
            right: 20px;
            padding: 15px 10px;
            font-size: 10px;
          }
        }

        @media (max-width: 576px) {
          .marquee-text {
            font-size: 2rem;
          }
        }
      `}</style>

      <section className="marquee-container">
        <div className="marquee-content">
          {/* First set of text */}
          <div className="marquee-text">
            <span className="text-dark">Brand</span>
          
            <span className="text-dark">AI Strategy - AI Development - Intelligent Automation - </span>
          </div>
          {/* Duplicate for seamless loop */}
          <div className="marquee-text">
            <span className="text-dark">Brand</span>
          
            <span className="text-dark">AI Strategy - AI Development - Intelligent Automation - </span>
          </div>
          {/* Third duplicate for extra smooth loop */}
          <div className="marquee-text">
            <span className="text-dark">Brand</span>
          
            <span className="text-dark">AI Strategy - AI Development - Intelligent Automation - </span>
          </div>
        </div>

        {/* Scroll Badge on Right */}
        <div className="scroll-badge">
          SCROLL
        </div>
      </section>
    </>
  );
}